import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import TopNav from "./TopNav";

function DefaultLayout() {
    return (
        <div>
            <TopNav />
            <Outlet />
            <Footer />
        </div>
    );
}

export default DefaultLayout;